// import React from 'react';
// import { Badge } from '@material-ui/core';
// import { useStyle } from './styles';
// import { Link } from 'react-router-dom';

export const Dispute = (): null => {
  // const classes = useStyle();

  return null;
  // return (
  //   <div>
  //     <Link to='/producer/request-management'>
  //       <div className={classes.content}>
  //         <div className={classes.type}>
  //           <h4>Disputas pendentes</h4>
  //           <Badge badgeContent={2} color='error' classes={{ badge: classes.badgePosition }} showZero></Badge>
  //         </div>
  //       </div>
  //     </Link>
  //   </div>
  // );
};
